module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-pers",
    class: {
      '-fixed-height-box': _vm.pcDisp
    },
    attrs: {
      "id": "pers-tab15",
      "name": "hres31x-tab15"
    }
  }, [_vm._l((_vm.detail.tableHonorsData.rows), function(value, index) {
    return [_c('detail-template', {
      attrs: {
        "index": index,
        "labels": _vm.labels,
        "detail": _vm.detail
      },
      inlineTemplate: {
        render: function() {
          var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
            return _c('div', [_c('div', {
              staticClass: "sub-topic-box color-skin",
              attrs: {
                "slot": "head"
              },
              on: {
                "click": function($event) {
                  _vm.toggleDisp()
                }
              },
              slot: "head"
            }, [_c('i', {
              staticClass: "fa fa-gift icon-sub-topic",
              attrs: {
                "aria-hidden": "true"
              }
            }), _vm._v(" "), _c('div', {
              staticClass: "sub-topic"
            }, [_vm._v(_vm._s(_vm.labels['HRES31XC13']['10']) + " ( " + _vm._s(_vm.labels['HRES31XC19']['20']) + "  " + _vm._s(index + 1) + " )")])]), _vm._v(" "), _c('div', {
              directives: [{
                name: "show",
                rawName: "v-show",
                value: (_vm.topicDisp),
                expression: "topicDisp"
              }],
              staticClass: "data-pers-box",
              attrs: {
                "slot": "body"
              },
              slot: "body"
            }, [_c('div', {
              staticClass: "row data-box"
            }, [_c('div', {
              staticClass: "col-xs-6 data-label"
            }, [_vm._v(_vm._s(_vm.labels['HRES31XC13']['20']))]), _vm._v(" "), _c('div', {
              staticClass: "col-xs-6 data-text"
            }, [_vm._v(_vm._s(_vm.setDateOutput(value.dteinput)))])]), _vm._v(" "), _c('div', {
              staticClass: "row data-box"
            }, [_c('div', {
              staticClass: "col-xs-6 data-label"
            }, [_vm._v(_vm._s(_vm.labels['HRES31XC13']['30']))]), _vm._v(" "), _c('div', {
              staticClass: "col-xs-6 data-text"
            }, [_vm._v(_vm._s(value.typrewd))])]), _vm._v(" "), _c('div', {
              staticClass: "row data-box"
            }, [_c('div', {
              staticClass: "col-xs-6 data-label"
            }, [_vm._v(_vm._s(_vm.labels['HRES31XC13']['40']))]), _vm._v(" "), _c('div', {
              staticClass: "col-xs-6 data-text"
            }, [_vm._v(_vm._s(value.desrewd1))])]), _vm._v(" "), _c('div', {
              staticClass: "row data-box"
            }, [_c('div', {
              staticClass: "col-xs-6 data-label"
            }, [_vm._v(_vm._s(_vm.labels['HRES31XC13']['50']))]), _vm._v(" "), _c('div', {
              staticClass: "col-xs-6 data-text"
            }, [_vm._v(_vm._s(value.numhmref))])])])])
          
        },
        staticRenderFns: []
      }
    })]
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-154b6225!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hres31x/tab15.vue
// module id = 3581
// module chunks = 1